import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import RequiresTemplateConfiguration from "../components/dependencies/RequiresTemplateConfiguration";
import HasRequiredAuthority from "../components/dependencies/HasRequiredAuthority";
import NotFound from "../pages/NotFound";
import Users from "../components/manage_users/Users";
import ManageUsers from "../pages/ManageUsers";
import User from "../components/manage_users/User";
import Basics from "../components/manage_users/user/Basics";
import Inquiries from "../components/manage_users/user/Inquiries";
import Enrollments from "../components/manage_users/user/Enrollments";
import Roles from "../components/manage_users/user/Roles";
import Wallet from "../components/manage_users/user/Wallet";
import ManageRoles from "../pages/ManageRoles";
import ManageAuthorities from "../pages/ManageAuthorities";
import Categories from "../components/catelogue/Categories";
import Courses from "../components/catelogue/Courses";
import Catelogue from "../pages/Catelogue";
import Course from "../pages/Course";
import Subjects from "../components/course/Subjects";
import { Chapters } from "../components/course/Chapters";
import ManageChapterTypes from "../pages/ManageChapterTypes";
import ManageCouponCodes from "../pages/ManageCouponCodes";
import CouponCodes from "../components/manage_coupon_codes/CouponCodes";
import CouponCodeCourses from "../components/manage_coupon_codes/CouponCodeCourses";
import ManageBatches from "../pages/ManageBatches";
import ManageTasks from "../pages/ManageTasks";
import Batches from "../components/manage_batches/Batches";
import BatchDetail from "../components/manage_batches/BatchDetail";
import BatchAttendance from "../components/manage_batches/BatchAttendance";
import ManageBranches from "../pages/ManageBranches";
import UserBatches from "../components/manage_users/user/Batches";
import UserBatchAttendance from "../components/manage_users/user/UserBatchAttendance";
import UserSections from "../components/manage_users/user/UserSections";
import UserNotifications from "../components/manage_users/user/UserNotifications";
import ManageNotifications from "../components/manage_notifications/ManageNotifications";
import Tasks from "../components/manage_tasks/Tasks";
import TaskDetail from "../components/manage_tasks/TaskDetail";
import EnrollPage from "../pages/Enroll";
import MediaCatalogue from "../components/course/MediaCatalogue";
import Media from "../pages/Media";
import { AUTHORITIES } from "../constants";
import MyCourses from "../pages/MyCourses";
import Revenue from "../pages/Revenue";
import Devices from "../components/manage_users/user/Devices";
import ChaptersTest from "../pages/ChaptersTest";
import Selection from "../components/chapter_test/Selection";
import Appear from "../components/chapter_test/Appear";
import Result from "../components/chapter_test/Result";
import Policies from "../pages/Policies";
import ManageInquiries from "../pages/ManageInquiries";
import GlobalNotes from "../components/manage_users/user/GlobalNotes";
import CounselingNotes from "../components/manage_users/user/CounselingNotes";
import StreamSelectionTestResults from "../components/manage_users/user/StreamSelectionTestResults";
import ExamHistory from "../components/manage_users/user/ExamHistory";
import Activities from "../components/manage_users/user/Activities";
import ManageStreamSelection from "../pages/ManageStreamSelection";
import Questions from "../components/manage_stream_selection/question_categories/Questions";
import QRInvites from "../components/manage_stream_selection/QRInvites";
import QuestionCategories from "../components/manage_stream_selection/QuestionCategories";
import ContactUs from "../pages/ContactUs";
import RequiresAuthentication from "../components/dependencies/RequiresAuthentication";
import Tests from "../components/manage_stream_selection/Tests";
import Configs from "../components/manage_stream_selection/Configs";
import Suggestions from "../components/manage_stream_selection/Suggestions";
import ProcessGuestToken from "./ProcessGuestToken";
import Attempt from "../components/stream_selection_test/Attempt";
import Enroll from "../components/stream_selection_test/Enroll";
import TestResult from "../components/stream_selection_test/TestResult";
import Analysis from "../components/stream_selection_test/Analysis";
import RequiresGuestUser from "../components/dependencies/RequiresGuestUser";
import StreamSelectionTest from "../pages/StreamSelectionTest";
import About from "../components/stream_selection_test/About";
import PaymentGatewayPayLoad from "../pages/PaymentGatewayPayLoad";
import ManageExamSeries from "../pages/ManageExamSeries";
import ExamSeriesEnrollments from "../components/manage_exams/ExamSeriesEnrollments";
import ExamSeriesSubmissionsByUser from "../components/manage_exams/ExamSeriesSubmissionsByUser";
import ExamSeries from "../components/manage_exams/ExamSeries";
import ManageSeriesExams from "../components/manage_exams/Exams";
import ExamQuestions from "../components/manage_exams/ExamQuestions";
import StudentExamSeries from "../pages/ExamSeries";
import ExamSeriesList from "../components/exam_series/ExamSeriesList";
import ExamSeriesDetail from "../components/exam_series/ExamSeriesDetail";
import ExamSeriesMerit from "../components/exam_series/ExamSeriesMerit";
import ExamSeriesResult from "../components/exam_series/ExamSeriesResult";
import ExamSeriesPaidEnrollment from "../components/exam_series/ExamSeriesPaidEnrollment";
import ManagePromoDialogs from "../pages/ManagePromoDialogs";
import AttendExamLayout from "../pages/AttendExamLayout";
import AttendExam from "../components/exam/AttendExam";
import AssesCandidate from "../components/exam/AssesCandidate";
import ExamAttendLobby from "../components/exam/ExamAttendLobby";
import CalendarDay from "../components/calendar/CalendarDay";
import CalendarMonth from "../components/calendar/CalendarMonth";
import CalendarSettings from "../components/calendar/CalendarSettings";
import ManageEvents from "../components/manage_events/ManageEvents";
import AiPlanner from "../pages/AiPlanner";
import ManageWebsite from "../pages/ManageWebsite";
import { AboutSections, BranchesSections, BrochuresSections, ContactSections, CoursesSections, FacilitiesSections, GallerySections, HomeSections, NotificationsSections, SiteSections, TestimonialsSections, WebsiteCards } from "../components/manage_website/WebsiteSections";
import WebsiteAbout from "../components/manage_website/WebsiteAbout";
import WebsiteBranches from "../components/manage_website/WebsiteBranches";
import WebsiteBrochures from "../components/manage_website/WebsiteBrochures";
import WebsiteBrochureFolder from "../components/manage_website/WebsiteBrochureFolder";
import WebsiteBrochuresPage from "../components/manage_website/WebsiteBrochuresPage";
import WebsiteContact from "../components/manage_website/WebsiteContact";
import WebsiteCourseFeatures from "../components/manage_website/WebsiteCourseFeatures";
import WebsiteCourses from "../components/manage_website/WebsiteCourses";
import WebsiteCoursesPage from "../components/manage_website/WebsiteCoursesPage";
import WebsiteFacilities from "../components/manage_website/WebsiteFacilities";
import WebsiteFacilitiesPage from "../components/manage_website/WebsiteFacilitiesPage";
import WebsiteFooter from "../components/manage_website/WebsiteFooter";
import WebsiteGalleryAlbums from "../components/manage_website/WebsiteGalleryAlbums";
import WebsiteGalleryEvent from "../components/manage_website/WebsiteGalleryEvent";
import WebsiteGalleryFolder from "../components/manage_website/WebsiteGalleryFolder";
import WebsiteGalleryCategories from "../components/manage_website/WebsiteGalleryCategories";
import WebsiteGalleryMedia from "../components/manage_website/WebsiteGalleryMedia";
import WebsiteGalleryPage from "../components/manage_website/WebsiteGalleryPage";
import WebsiteHeader from "../components/manage_website/WebsiteHeader";
import { HomeBlock } from "../components/manage_website/WebsiteHome";
import WebsiteHomeAchievements from "../components/manage_website/WebsiteHomeAchievements";
import WebsiteHomeAppFeatures from "../components/manage_website/WebsiteHomeAppFeatures";
import WebsiteHomeBrochureCards from "../components/manage_website/WebsiteHomeBrochureCards";
import WebsiteHomeGalleryTiles from "../components/manage_website/WebsiteHomeGalleryTiles";
import WebsiteHomeHighlights from "../components/manage_website/WebsiteHomeHighlights";
import WebsiteLinks from "../components/manage_website/WebsiteLinks";
import WebsiteMobileBar from "../components/manage_website/WebsiteMobileBar";
import WebsiteNotificationNotice from "../components/manage_website/WebsiteNotificationNotice";
import WebsiteNotificationFiles from "../components/manage_website/WebsiteNotificationFiles";
import WebsiteNotificationImages from "../components/manage_website/WebsiteNotificationImages";
import WebsiteNotifications from "../components/manage_website/WebsiteNotifications";
import WebsiteNotificationsPage from "../components/manage_website/WebsiteNotificationsPage";
import WebsiteSeo from "../components/manage_website/WebsiteSeo";
import WebsiteSettings from "../components/manage_website/WebsiteSettings";
import WebsiteSocialLinks from "../components/manage_website/WebsiteSocialLinks";
import WebsiteStats from "../components/manage_website/WebsiteStats";
import WebsiteTestimonials from "../components/manage_website/WebsiteTestimonials";
import WebsiteInquiries from "../components/manage_website/inquiries/WebsiteInquiries";


export default function App() {


    return (
        <RequiresTemplateConfiguration>
            <Routes>

                    <Route element={<ProcessGuestToken />}>
                        <Route path="/stream-selection-test" element={<StreamSelectionTest />}>
                            <Route path="about" element={<About />} />
                            <Route element={<RequiresGuestUser />}>
                                <Route path="enroll" element={<Enroll />} />
                                <Route path="attempt" element={<Attempt />} />
                                <Route path="result" element={<TestResult />} />
                                <Route path="analysis" element={<Analysis />} />
                            </Route>
                        </Route>
                    </Route>

                    <Route path="/payment-gateway-payloads/:paymentGatewayPayloadId" element={<PaymentGatewayPayLoad />} />
                    <Route path="/contact-us" element={<ContactUs />} />

                    <Route element={<RequiresAuthentication />}>
                        <Route index element={<Dashboard />} />
                        <Route path="/ai-planner" element={<AiPlanner />} />
                        <Route path="/policies" element={<Policies />} />
                        <Route path="/calendar" element={<CalendarMonth />} />
                        <Route path="/calendar/day" element={<CalendarDay />} />
                        <Route
                            path="/manage-calendar-settings"
                            element={
                                <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.USE_ADMIN_CORNER}>
                                    <CalendarSettings />
                                </HasRequiredAuthority>
                            }
                        />
                        <Route
                            path="/manage-events"
                            element={
                                <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.USE_PAGE_MANAGE_EVENTS}>
                                    <ManageEvents />
                                </HasRequiredAuthority>
                            }
                        />
                        <Route
                            path="/manage-notifications"
                            element={
                                <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.USE_PAGE_MANAGE_NOTIFICATIONS}>
                                    <ManageNotifications />
                                </HasRequiredAuthority>
                            }
                        />
                        <Route path="/manage-users" element={<ManageUsers />}>
                            <Route
                                index
                                element={
                                    <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.MANAGE_OTHER_USERS}>
                                        <Users />
                                    </HasRequiredAuthority>
                                }
                            />
                            <Route path=":userId" element={<User />}>
                                <Route index element={<UserSections />} />
                                <Route path="basics" element={<Basics />} />
                                <Route path="notifications" element={<UserNotifications />} />
                                <Route
                                    path="inquiries"
                                    element={
                                        <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.MANAGE_OTHER_USERS}>
                                            <Inquiries />
                                        </HasRequiredAuthority>
                                    }
                                />
                                <Route path="enrollments" element={<Enrollments />} />
                                <Route path="exam-history" element={<ExamHistory />} />
                                <Route path="activities" element={<Activities />} />
                                <Route
                                    path="stream-selection-test-results"
                                    element={
                                        <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.MANAGE_OTHER_USERS}>
                                            <StreamSelectionTestResults />
                                        </HasRequiredAuthority>
                                    }
                                />
                                <Route path="devices" element={<Devices />} />
                                <Route path="wallet" element={<Wallet />} />
                                <Route path="global-notes" element={<GlobalNotes />} />
                                <Route path="counseling-notes" element={<CounselingNotes />} />
                                <Route
                                    path="roles"
                                    element={
                                        <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.MANAGE_OTHER_USERS}>
                                            <Roles />
                                        </HasRequiredAuthority>
                                    }
                                />
                                <Route path="batches" element={<UserBatches />} />
                                <Route path="batches/:batchId/attendance" element={<UserBatchAttendance />} />
                            </Route>
                        </Route>
                        <Route
                            path="/manage-inquiries"
                            element={
                                <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.USE_PAGE_INQUIRIES}>
                                    <ManageInquiries />
                                </HasRequiredAuthority>
                            }
                        />
                        <Route path="/course-categories" element={<Catelogue />}>
                            <Route index element={<Categories />} />
                            <Route path=":categoryId/courses" element={<Courses />} />
                        </Route>
                        <Route path="/courses/:courseId" element={<Course />}>
                            <Route path="subjects" element={<Subjects />} />
                            <Route path="subjects/:subjectId">
                                <Route path="chapters" element={<Chapters />} />
                                <Route path="chapters/:chapterId">
                                    <Route path="media" element={<MediaCatalogue />} />
                                </Route>
                            </Route>
                        </Route>
                        <Route path="/my-courses" element={<MyCourses />}></Route>
                        <Route path="/exam-series" element={<StudentExamSeries />}>
                            <Route path="list" element={<ExamSeriesList />} />
                            <Route path="paid-enrollment/:id" element={<ExamSeriesPaidEnrollment />} />
                            <Route path=":id/merit" element={<ExamSeriesMerit />} />
                            <Route path=":id/result" element={<ExamSeriesResult />} />
                            <Route path=":id" element={<ExamSeriesDetail />} />
                        </Route>
                        <Route path="/exams/:examId" element={<AttendExamLayout />}>
                            <Route index element={<ExamAttendLobby />} />
                            <Route path="assess-candidate" element={<AssesCandidate />} />
                            <Route path="assess-candidate/attend" element={<AttendExam />} />
                        </Route>
                        <Route path="/media-player/:mediaId" element={<Media />}></Route>
                        <Route path="/manage-chapter-types" element={<ManageChapterTypes />} />
                        <Route
                            path="/manage-promo-dialogs"
                            element={
                                <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.UPDATE_COURSE}>
                                    <ManagePromoDialogs />
                                </HasRequiredAuthority>
                            }
                        />
                        <Route path="/chapters-test" element={<ChaptersTest />}>
                            <Route path="selection" element={<Selection />} />
                            <Route path="appear" element={<Appear />} />
                            <Route path="result" element={<Result />} />
                        </Route>
                        <Route path="/manage-coupon-codes" element={<ManageCouponCodes />}>
                            <Route index element={<CouponCodes />}></Route>
                            <Route path=":couponCodeId/courses" element={<CouponCodeCourses />} />
                        </Route>
                        <Route
                            path="/manage-batches"
                            element={
                                <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.USE_PAGE_MANAGE_BATCHES}>
                                    <ManageBatches />
                                </HasRequiredAuthority>
                            }
                        >
                            <Route index element={<Batches />} />
                        </Route>
                        <Route
                            path="/user-tasks"
                            element={
                                <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.USE_PAGE_TASKS}>
                                    <ManageTasks />
                                </HasRequiredAuthority>
                            }
                        >
                            <Route index element={<Navigate to="assigned" replace />} />
                            <Route path="assigned" element={<Tasks scope="assigned" />} />
                            <Route
                                path="created"
                                element={
                                    <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.CREATE_USER_TASK}>
                                        <Tasks scope="created" />
                                    </HasRequiredAuthority>
                                }
                            />
                            <Route
                                path="all"
                                element={
                                    <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.READ_ALL_USER_TASKS}>
                                        <Tasks scope="all" />
                                    </HasRequiredAuthority>
                                }
                            />
                            <Route path=":taskId" element={<TaskDetail />} />
                        </Route>
                        <Route
                            path="/manage-batches/:batchId/attendance"
                            element={
                                <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.MANAGE_BATCH_ATTENDANCE}>
                                    <BatchAttendance />
                                </HasRequiredAuthority>
                            }
                        />
                        <Route
                            path="/manage-batches/:batchId"
                            element={
                                <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.USE_PAGE_MANAGE_BATCHES}>
                                    <BatchDetail />
                                </HasRequiredAuthority>
                            }
                        />
                        <Route
                            path="/manage-branches"
                            element={
                                <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.USE_PAGE_MANAGE_BRANCHES}>
                                    <ManageBranches />
                                </HasRequiredAuthority>
                            }
                        />
                        <Route
                            path="/manage-roles"
                            element={
                                <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.MANAGE_OTHER_USERS}>
                                    <ManageRoles />
                                </HasRequiredAuthority>
                            }
                        />
                        <Route
                            path="/manage-authorities"
                            element={
                                <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.MANAGE_OTHER_USERS}>
                                    <ManageAuthorities />
                                </HasRequiredAuthority>
                            }
                        />

                        <Route path="/manage-stream-selection" element={<ManageStreamSelection />}>
                            <Route path="configs" element={<Configs />} />
                            <Route path="suggestions" element={<Suggestions />} />
                            <Route path="tests" element={<Tests />} />
                            <Route path="qr-invites" element={<QRInvites />} />
                            <Route path="question-categories">
                                <Route index element={<QuestionCategories />} />
                                <Route path=":id" element={<Questions />} />
                            </Route>
                        </Route>

                        <Route path="/enroll/:courseId" element={<EnrollPage />} />
                        <Route
                            path="/manage-exam-series"
                            element={
                                <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.USE_PAGE_MANAGE_EXAMS}>
                                    <ManageExamSeries />
                                </HasRequiredAuthority>
                            }
                        >
                            <Route path="exam-series" element={<ExamSeries />} />
                            <Route path="enrollments/:id" element={<ExamSeriesEnrollments />} />
                            <Route path=":exam_series_id/users/:user_id/submissions" element={<ExamSeriesSubmissionsByUser />} />
                            <Route path=":id/exams" element={<ManageSeriesExams />} />
                            <Route path="exams/:id/questions" element={<ExamQuestions />} />
                        </Route>
                        <Route path="/revenue" element={<Revenue />} />
                        <Route
                            path="/manage-website"
                            element={
                                <HasRequiredAuthority showForBidden={true} requiredAuthority={AUTHORITIES.USE_ADMIN_CORNER}>
                                    <ManageWebsite />
                                </HasRequiredAuthority>
                            }
                        >
                            <Route index element={<WebsiteCards />} />
                            <Route path="inquiries" element={<WebsiteInquiries />} />
                            <Route path="pages/site" element={<SiteSections />} />
                            <Route path="pages/facilities" element={<FacilitiesSections />} />
                            <Route path="pages/notifications" element={<NotificationsSections />} />
                            <Route path="pages/testimonials" element={<TestimonialsSections />} />
                            <Route path="pages/gallery" element={<GallerySections />} />
                            <Route path="pages/brochures" element={<BrochuresSections />} />
                            <Route path="pages/courses" element={<CoursesSections />} />
                            <Route path="pages/contact" element={<ContactSections />} />
                            <Route path="pages/branches" element={<BranchesSections />} />
                            <Route path="site-settings" element={<WebsiteSettings />} />
                            <Route path="seo" element={<WebsiteSeo />} />
                            <Route path="header" element={<WebsiteHeader />} />
                            <Route path="links" element={<WebsiteLinks />} />
                            <Route path="footer" element={<WebsiteFooter />} />
                            <Route path="mobile-bar" element={<WebsiteMobileBar />} />
                            <Route path="home" element={<HomeSections />} />
                            <Route path="home/hero" element={<HomeBlock section="hero" />} />
                            <Route path="home/stats" element={<HomeBlock section="stats" List={WebsiteStats} />} />
                            <Route path="home/about" element={<HomeBlock section="about" List={WebsiteHomeHighlights} />} />
                            <Route path="home/founder" element={<HomeBlock section="founder" />} />
                            <Route path="home/facilities" element={<HomeBlock section="facilities" />} />
                            <Route path="home/courses" element={<HomeBlock section="courses" />} />
                            <Route path="home/app" element={<HomeBlock section="app" List={WebsiteHomeAppFeatures} />} />
                            <Route path="home/mission" element={<HomeBlock section="mission" />} />
                            <Route path="home/testimonials" element={<HomeBlock section="testimonials" />} />
                            <Route path="home/achievements" element={<HomeBlock section="achievements" List={WebsiteHomeAchievements} />} />
                            <Route path="home/gallery" element={<HomeBlock section="gallery" List={WebsiteHomeGalleryTiles} />} />
                            <Route path="home/brochures" element={<HomeBlock section="brochures" List={WebsiteHomeBrochureCards} />} />
                            <Route path="home/free-content" element={<HomeBlock section="free" />} />
                            <Route path="home/contact" element={<HomeBlock section="contact" List={WebsiteSocialLinks} />} />
                            <Route path="stats" element={<WebsiteStats />} />
                            <Route path="home-highlights" element={<WebsiteHomeHighlights />} />
                            <Route path="home-app-features" element={<WebsiteHomeAppFeatures />} />
                            <Route path="home-achievements" element={<WebsiteHomeAchievements />} />
                            <Route path="home-gallery-tiles" element={<WebsiteHomeGalleryTiles />} />
                            <Route path="home-brochure-cards" element={<WebsiteHomeBrochureCards />} />
                            <Route path="branches" element={<WebsiteBranches />} />
                            <Route path="courses" element={<WebsiteCourses />} />
                            <Route path="course-features" element={<WebsiteCourseFeatures />} />
                            <Route path="facilities" element={<WebsiteFacilities />} />
                            <Route path="notifications" element={<WebsiteNotifications />} />
                            <Route path="notifications/:noticeId" element={<WebsiteNotificationNotice />} />
                            <Route path="notification-images" element={<WebsiteNotificationImages />} />
                            <Route path="notification-files" element={<WebsiteNotificationFiles />} />
                            <Route path="testimonials-page" element={<HomeBlock section="testimonials" />} />
                            <Route path="testimonials" element={<WebsiteTestimonials />} />
                            <Route path="social-links" element={<WebsiteSocialLinks />} />
                            <Route path="about" element={<AboutSections />} />
                            <Route path="about/text" element={<WebsiteAbout />} />
                            <Route path="courses-page" element={<WebsiteCoursesPage />} />
                            <Route path="facilities-page" element={<WebsiteFacilitiesPage />} />
                            <Route path="notifications-page" element={<WebsiteNotificationsPage />} />
                            <Route path="contact" element={<WebsiteContact />} />
                            <Route path="gallery-page" element={<WebsiteGalleryPage />} />
                            <Route path="gallery-categories" element={<WebsiteGalleryCategories />} />
                            <Route path="gallery/folders/:slug" element={<WebsiteGalleryFolder />} />
                            <Route path="gallery/folders/:slug/events/:albumId" element={<WebsiteGalleryEvent />} />
                            <Route path="gallery-albums" element={<WebsiteGalleryAlbums />} />
                            <Route path="gallery-media" element={<WebsiteGalleryMedia />} />
                            <Route path="brochures-page" element={<WebsiteBrochuresPage />} />
                            <Route path="brochures" element={<WebsiteBrochures />} />
                            <Route path="brochures/folders/:courseKey" element={<WebsiteBrochureFolder />} />
                        </Route>
                    </Route>

                    <Route path="*" element={<NotFound />} />
            </Routes>
        </RequiresTemplateConfiguration>
    );
}
